import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { RoutingInstructions } from '@xpo-ltl/sdk-reference';
import * as _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { delay, retryWhen, take, takeUntil } from 'rxjs/operators';
import { RouteTypesData } from '../../classes/route-types-data';
import { RoutingInstructionsCacheService } from '../../services/routing-instructions-cache.service';

@Component({
  selector: 'app-route-types',
  templateUrl: './route-types.component.html',
  styleUrls: ['./route-types.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RouteTypesComponent implements OnInit, OnDestroy {
  private routeListSubject = new BehaviorSubject<RoutingInstructions[]>([]);
  public routeList$ = this.routeListSubject.asObservable();
  public selectedRoute: RoutingInstructions;
  private searchingSubject = new BehaviorSubject<boolean>(true);
  public searching$ = this.searchingSubject.asObservable();

  @ViewChild('selectList', { static: true })
  selectList: MatSelectionList;

  private unsubscriber = new Subject<void>();

  constructor(private dialogRef: MatDialogRef<RouteTypesComponent>, @Inject(MAT_DIALOG_DATA) public data: RouteTypesData, private routingInstructionsCache: RoutingInstructionsCacheService) {}

  ngOnInit() {
    this.routingInstructionsCache
      .request({
        origSicCd: this.data.origin,
        destSicCd: this.data.destination,
      })
      .pipe(
        retryWhen(errors =>
          errors.pipe(
            delay(1000),
            take(10)
          )
        )
      )
      .subscribe(
        routingInstructions => {
          if (routingInstructions && routingInstructions.length > 0) {
            this.routeListSubject.next(_.sortBy(routingInstructions, item => item.tripCd));
          }

          this.searchingSubject.next(false);
        },
        error => {
          this.searchingSubject.next(false);
        }
      );

    this.selectList.selectionChange.pipe(takeUntil(this.unsubscriber)).subscribe(selChange => {
      this.selectList.deselectAll();
      selChange.options[0].selected = true;
      this.selectedRoute = this.selectList.selectedOptions.selected[0].value;
    });
  }

  ngOnDestroy() {
    this.unsubscriber.next();
    this.unsubscriber.complete();
    this.unsubscriber = undefined;
  }

  cancelClicked() {
    this.dialogRef.close();
  }

  doneClicked() {
    const selectedItem = this.selectList.selectedOptions.selected[0];
    this.dialogRef.close(this.selectedRoute);
  }
}
